var React = require('react');

function GithubStar (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"fill":"#010101","points":"42.022,19.07 30.223,17.366 24.953,6.752 19.684,17.366 7.885,19.07 16.423,27.343 14.41,39.016 \r\n\t24.953,33.505 35.497,39.016 33.484,27.343 "}));
}

GithubStar.defaultProps = {"version":"1.1","id":"Layer_2","x":"0px","y":"0px","width":"48px","height":"48px","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48","xmlSpace":"preserve"};

module.exports = GithubStar;

GithubStar.default = GithubStar;
